import React from 'react'
import "./Takeaways.css"
import way from "./img/way.png"
import t1 from "./img/t1.png"
import t2 from "./img/t2.png"
import t3 from "./img/t3.png"
import t4 from "./img/t4.png"

import background from "./img/background.png"
function Takeaways() {
  return (
    <div className='takeaways'
    style={{backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition:"right center"
   }}> 
     <h2>What you will <span style={{color:"#4E62D6"}}>learn?</span> </h2>
     <div className="way-points">
        <div className="way-img">
    <img src={way} alt="" height={400} />
        </div>
        <div className="way-text"style={{ marginTop: '50px' }}>
    <div className="point">
       <div className="point-item">
        <img src={t1} alt="" />
       <p>Personalized Exercises: Energize and strengthen your body with quick, practical movements tailored to your busy schedule.</p>
       </div>
       <div className="point-item">
       <img src={t2} alt="" />

       <p>Practical Nutrition Hacks: Fuel your performance with easy-to-follow strategies for better focus and stamina.</p>
       </div>
       <div className="point-item">
       <img src={t3} alt="" />

       <p>Proven Strategy: Build a sustainable approach to health—because tactics without strategy don’t work.</p>
       </div>
    </div>
        </div>
        </div>  
    </div>
  )
}


export default Takeaways
